<template>
    <div>
        <h3 class="text-lg leading-6 font-medium text-secondaryColor mb-4">
            {{ value.label }}
        </h3>
        <div v-if="typeof value.value === 'object'">
            <span v-for="item in value.value" :key="item.value">
                {{ item }}
            </span>
        </div>
      <div v-if="typeof value.value === 'boolean'">
        <span>{{ $t(`post.page.answers.boolean.${value.value}`) }}</span>
      </div>
      <div v-else>
        <span>{{ value.value }}</span>
      </div>
    </div>
</template>

<script>
export default {
    name: 'CheckboxAttribute',
    props: ['value']
}
</script>

<style scoped></style>
